export default __webpack_public_path__ + "static/media/MARKPROMEDIUM.e66bb25f.woff";